const gap = 100

export const isElementVisible = (el: HTMLElement) => {
  const scroll = window.scrollY || window.pageYOffset
  const boundsTop = el.getBoundingClientRect().top + scroll

  const viewport = {
    top: scroll + gap,
    bottom: scroll + window.innerHeight - gap,
  }

  const bounds = {
    top: boundsTop,
    bottom: boundsTop,
  }

  return (
    (bounds.bottom >= viewport.top && bounds.bottom <= viewport.bottom) ||
    (bounds.top <= viewport.bottom && bounds.top >= viewport.top)
  )
}
